import { FunnelType } from 'scenes/common/types';

export const route = <S>(funnel: FunnelType, pagetype: S) =>
  `/${funnel}${pagetype && `/${pagetype}`}`;

export const isPaymentFunnel = (funnel: FunnelType): boolean =>
  !funnel || funnel === FunnelType.Payment;
